import type { SanityPageBuilderCoreVideoFeaturesGalleryItem, SanityPageBuilderCoreVideoFeaturesGallerySection, SanityPageBuilderSection } from "@ouster/shared";
import { CoreVideoFeaturesGalleryBlockView } from "~/features/blocks/inventory/core-video-features-gallery";
import type { CoreVideoFeaturesGalleryViewItem } from "~/features/blocks/inventory/core-video-features-gallery/shared";
import { toCraftMedia, toCraftThumbnail } from "~/features/sanity/media";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderCoreVideoFeaturesGallerySection;
  };
};
type CoreVideoFeaturesGalleryViewItemWithKey = CoreVideoFeaturesGalleryViewItem & Pick<SanityPageBuilderCoreVideoFeaturesGalleryItem, "_key">;
export function SanityCoreVideoFeaturesGallerySection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const items = sectionContent.items?.map<CoreVideoFeaturesGalleryViewItemWithKey>(item => {
    return {
      _key: item._key,
      headline: item.headline,
      description: item.description?.length ? <SanityRichText value={item.description} /> : undefined,
      media: toCraftMedia(item.media),
      thumbnail: toCraftThumbnail(item.media)
    };
  }) ?? [];
  return <CoreVideoFeaturesGalleryBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} isHighlighted={sectionContent.isHighlighted} items={items} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} />;
}